import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    chgNo: {
        name: () => '系统变更单编号',
    },

    chgTitle: {
        name: () => '标题',
    },
})
